<template>
  <div class="sdg" style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255); padding-bottom: 50px" v-if="pay_way">
    <div style="width: 100%; background: #fff">
      <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #f7f8fa" title="存款" left-arrow @click-left="$router.back()" />
      <div style="height: 46px"></div>
      <!-- 存款方式选择 -->
      <div class="typelis">
        <div :class="pay_way == 'alipay' ? ' tyls atc' : 'tyls'" @click="changPayway('alipay')" v-if="payWayList.alipay == 1"><img src="/static/image/icoAlipay2@3x.png" alt="" />支付宝</div>
        <div :class="pay_way == 'wechat' ? ' tyls atc' : 'tyls'" @click="changPayway('wechat')" v-if="payWayList.wechat == 1"><img src="/static/image/QuickWechat.png" alt="" />微信</div>
        <div :class="pay_way == 'usdt' ? ' tyls atc' : 'tyls'" @click="changPayway('usdt')" v-if="payWayList.usdt == 1"><img src="/static/image/1595237922936176.png" alt="" />USDT</div>
      </div>
      <div v-if="pay_way == 'bank' && !(userbank.length == 0 && userUSD.length == 0)">
        <div class="usrse">
          <div class="bans" style="" v-for="(item, index) in cardLis" :key="index">
            <p>
              <span class="frists"> 收款账号 </span><span class="sdsw">{{ item.bank_no }}</span
              ><span class="copy" @click="doCopy(item.bank_no)"> 复制 </span>
            </p>
            <p>
              <span class="frists"> 银行户名 </span><span class="sdsw">{{ item.bank_owner }}</span
              ><span class="copy" @click="doCopy(item.bank_owner)"> 复制 </span>
            </p>
            <p>
              <span class="frists"> 开户行 </span><span class="sdsw">{{ item.bank_data.bank_name }}</span
              ><span class="copy" @click="doCopy(item.bank_data.bank_name)"> 复制 </span>
            </p>
            <p>
              <span class="frists"> 银行地址 </span><span class="sdsw">{{ item.bank_address }}</span
              ><span class="copy" @click="doCopy(item.bank_address)"> 复制 </span>
            </p>
          </div>
          <div class="hgs" @click="changShow">
            <div class="nams">开户银行</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank" type="text" placeholder="选择开户银行" disabled> </van-field>
              </van-cell-group>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">存款人姓名</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_owner" type="text" placeholder="请输入存款人姓名"> </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg">为及时到账，请务必输入正确的存款人姓名</div>
          </div>

          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">银行卡号</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_no" type="text" placeholder="请输入银行卡号"> </van-field>
              </van-cell-group>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">开户行地址</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="bankBox.bank_address" type="text" placeholder="请输入开户行地址"> </van-field>
              </van-cell-group>
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="text" :placeholder="`请输入取款金额 ${min_price} - ${max_price}`">
                  <template #button> <span style="color: #000"> 元</span> </template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg"></div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
        </div>
      </div>
      <div v-if="pay_way == 'usdt'">
        <div class="tipsh">
          <div class="tops">USDT 价格稳定 · 到账自动上分 <span @click="$parent.goNav('/usdtmore')">了解更多 ></span></div>
          <div class="tsg">
            <div class="tsgs">① 选择协议</div>
            <div class="tsgs">② 复制地址转账</div>
            <div class="tsgs">③ 自动到账上分</div>
          </div>
        </div>
        <div class="usrse">
          <div class="usdtbanner">
            <div class="ub-title">💎 这是您在新葡京娱乐城的专属充值地址</div>
            <div class="ub-desc">地址长期有效、可反复使用。只需向下方地址转入 USDT（单笔不低于 <b>{{ usdtMin }}</b>），系统即自动为您完成上分，<b>无需下单、无需提交凭证、无需等待人工审核</b>。</div>
          </div>
          <div class="hgs">
            <div class="nams sc">
              钱包协议
              <div :class="meyXi == 'TRC20' ? ' ssa acti' : 'ssa'" @click="changXiyi('TRC20')" v-if="usdtNetworks.indexOf('trc20') > -1">TRC20</div>
              <div :class="meyXi == 'ERC20' ? ' ssa acti' : 'ssa'" style="margin-left: 0.5rem" @click="changXiyi('ERC20')" v-if="usdtNetworks.indexOf('erc20') > -1">ERC20</div>
            </div>
            <div style="border-bottom: 1px solid #f2f2f2"></div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <!-- 固定收款地址 + 二维码 -->
          <div class="hgs" v-if="usdtAddr.address">
            <div class="nams">{{ meyXi }} 专属收款地址</div>
            <div class="usdtaddrbox">
              <div class="addrtxt">{{ usdtAddr.address }}</div>
              <span class="copy" @click="doCopy(usdtAddr.address)">复制</span>
            </div>
            <div class="qrwrap" v-if="usdtAddr.qr_code">
              <img :src="usdtAddr.qr_code" alt="收款二维码" />
              <div class="qrtip">扫码转账</div>
            </div>
            <div class="lasthg" v-if="usdtAddr.memo" style="color: #b02a37; font-weight: 700">Memo/Tag：{{ usdtAddr.memo }}（务必填写，否则无法到账）</div>
          </div>
          <div class="hgs" v-else>
            <div class="lasthg" style="justify-content: center; color: #a5a9b3">地址加载中…如长时间无地址请稍后重试或联系客服</div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <!-- 金额换算器(选填,仅预览) -->
          <div class="hgs">
            <div class="nams">金额换算器（选填 · 仅供预估）</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field v-model="usdtAmount" type="number" :placeholder="`输入 USDT 预估人民币，单笔≥${usdtMin}`">
                  <template #button> <span style="color: #000"> USDT</span> </template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="lasthg" v-if="usdtAmount && usdtAmount * 1 < usdtMin" style="color: #e02020; padding-bottom: 0">单笔最低充值 {{ usdtMin }} USDT</div>
            <div class="lasthg"><span style="color: #2f6bff; font-size: 0.43rem; margin-right: 10px">≈ </span> 折合人民币 ￥{{ usdtAmount ? (usdtAmount * usdtRate).toFixed(2) : '0.00' }} （实时汇率 {{ usdtRate }}）</div>
            <div class="lasthg" style="color: #999; font-size: 0.3rem; padding-top: 0">此框仅帮您预估到账人民币，<b>无需按此金额精确转账</b>；实际以到账 USDT × 到账时实时汇率折算上分。</div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <!-- 充值须知 -->
          <div class="hgs">
            <div class="nams">充值须知</div>
            <div class="lasthg" style="display: block; line-height: 1.7; border-top: 1px solid #eee; margin-top: 10px">
              1. 仅支持 <b style="color: #2f6bff">{{ meyXi }}</b> 网络，请务必用该网络转账 USDT 到上方地址，选错网络资产无法找回。<br />
              2. 单笔不低于 <b>{{ usdtMin }} USDT</b>，同一专属地址可反复转入、金额随意，无需每次通知客服。<br />
              3. 到账后按<b>实收 USDT × 到账时实时汇率</b>自动折算人民币上分，无需提交凭证或截图。<br />
              4. 网络确认后通常 1-3 分钟自动到账；如超过 10 分钟未到，请联系客服并提供转账哈希（TxID）。
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="lasthg" style="justify-content: center; color: #1e7e34">● 正在监听到账，转账成功后自动上分并刷新余额</div>
          </div>
        </div>
      </div>
      <div v-if="pay_way == 'wechat' || pay_way == 'alipay'">
        <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
        <div class="usrse">
          <div class="hgs">
            <div class="nams">选择通道</div>
            <div class="prodlist">
              <div v-for="p in products" :key="p.id" :class="selectedProduct && selectedProduct.id == p.id ? 'proditem acti' : 'proditem'" @click="selectProduct(p)">
                <img v-if="p.icon" :src="p.icon" alt="" />
                <img v-else :src="pay_way == 'alipay' ? '/static/image/icoAlipay2@3x.png' : '/static/image/QuickWechat.png'" alt="" />
                <div class="pname">{{ p.name }}</div>
                <div class="prange">{{ p.min_price }}-{{ p.max_price }}</div>
              </div>
            </div>
            <div v-if="products.length == 0" class="lasthg" style="justify-content: center">该方式维护中,请稍后再试</div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs" v-if="selectedProduct">
            <div class="nams">存款金额</div>
            <div style="border-bottom: 1px solid #f2f2f2">
              <van-cell-group>
                <van-field label="￥" v-model="amount" type="number" :placeholder="`请输入金额 ${selectedProduct.min_price} - ${selectedProduct.max_price}`">
                  <template #button> <span style="color: #000"> 元</span> </template>
                </van-field>
              </van-cell-group>
            </div>
            <div class="quickbox" v-if="selectedProduct.quick_amounts && selectedProduct.quick_amounts.length">
              <span v-for="q in selectedProduct.quick_amounts" :key="q" :class="amount == q ? 'quickitem acti' : 'quickitem'" @click="changMey(q)">{{ q }}</span>
            </div>
            <div class="lasthg" v-if="selectedProduct.tip">{{ selectedProduct.tip }}</div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
          <div class="hgs">
            <div class="nams">充值须知</div>
            <div class="lasthg" style="display: block; line-height: 1.6">
              1. 请在下单后 5 分钟内完成支付,超时订单自动关闭。<br />
              2. 转账金额必须与订单金额完全一致,否则无法自动到账。<br />
              3. 请使用本人实名账户支付,勿复用旧收款码。<br />
              4. 正常 1-5 分钟到账,超时未到请联系客服并提供订单号。
            </div>
          </div>
          <div style="height: 0.2rem; background: #f8f8f8; width: 100wh"></div>
        </div>
      </div>
      <div style="margin: 0 auto; width: 86%">
        <van-button v-if="pay_way != 'usdt'" type="info" style="margin-top: 20px; width: 100%" @click="payTest">立即存款</van-button>
        <van-button v-else type="info" style="margin-top: 20px; width: 100%" @click="checkDepositNow">我已完成转账 / 刷新到账</van-button>
        <div class="textcns" style="text-align: center; color: #999; padding: 10px 0">存款遇到问题？联系 <span @click="$parent.openKefu" style="color: #2f6bff; display: inline-block; margin: 0 6px">人工客服</span> 解决</div>
      </div>
    </div>
    <div v-if="show" style="position: fixed; width: 100%; height: 100%; top: 0; z-index: 999; background: rgba(0, 0, 0, 0.39)">
      <van-picker style="position: absolute; bottom: 0; left: 0; width: 100%" title="银行类型" show-toolbar :columns="banklist" @confirm="onConfirm" @cancel="onCancel" @change="onChange" value-key="bank_name" />
    </div>
    <!-- 禁止   -->
    <div class="domainModal_domainView__FWCzg" v-if="userbank.length == 0 && userUSD.length == 0">
      <div class="domainModal_mask__24Y2m domainModal_fadeIn__1I3AS false" @click="$router.back()"></div>
      <div class="domainModal_content__1nBgc" style="width: 80%">
        <div id="domain" class="domainModal_contentTop__2C4jc">
          <img src="/static/image/hongbaocolse.png" @click="$router.back()" style="position: absolute; top: 5px; right: 13px; width: 0.6rem" alt="" />

          <div class="domainModal_top__1omYS">温馨提示</div>
          <div class="domainModal_middle__3gQPm" style="padding: 30px">您还为绑定任何钱包卡片，请前往绑定！</div>

          <div style="height: 30px; text-align: center; line-height: 30px; color: #fff" @click="$parent.goNav('/wallet')">前往绑定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      bankBox: {},
      meyXi: 'TRC20',
      payWayList: {},
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      products: [],
      selectedProduct: null,
      submitting: false,
      // USDT 自动上分(OxaPay 静态地址)
      usdtNetworks: [],
      usdtAddr: {},
      usdtRate: 0,
      usdtRateTime: '',
      usdtMin: 50,
      usdtAmount: null,
      depositTimer: null,
      knownDepositIds: [],
    };
  },
  created() {
    let that = this;
    that.getPayWay();
  },
  methods: {
    // 进入某方式即拉取对应数据
    loadPayData() {
      let that = this;
      if (that.pay_way == 'wechat' || that.pay_way == 'alipay') {
        that.getProducts();
      } else if (that.pay_way == 'usdt') {
        that.loadUsdtMeta().then(() => {
          that.loadUsdtAddress();
          that.startDepositWatch();
        });
      } else {
        that.getPayRange();
      }
    },
    // USDT:拉取启用网络 + 实时汇率 + 最低额
    loadUsdtMeta() {
      let that = this;
      return that.$apiFun
        .get('/api/usdt_rate', {})
        .then(res => {
          if (res.code == 200 && res.data) {
            that.usdtNetworks = res.data.networks || [];
            that.usdtRate = res.data.rate || 0;
            that.usdtRateTime = res.data.updated_at || '';
            that.usdtMin = res.data.min_deposit_usdt || 50;
            let cur = (that.meyXi || '').toLowerCase();
            if (that.usdtNetworks.length && that.usdtNetworks.indexOf(cur) < 0) {
              that.meyXi = that.usdtNetworks[0].toUpperCase();
            }
          }
        })
        .catch(() => {});
    },
    // USDT:获取/生成当前链的固定收款地址
    loadUsdtAddress() {
      let that = this;
      let net = (that.meyXi || '').toLowerCase();
      that.usdtAddr = {};
      that.showLoading();
      that.$apiFun
        .post('/api/usdt_deposit_address', { network: net })
        .then(res => {
          that.hideLoading();
          if (res.code == 200 && res.data) {
            that.usdtAddr = { address: res.data.address, memo: res.data.memo, qr_code: res.data.qr_code };
            if (res.data.rate) that.usdtRate = res.data.rate;
            if (res.data.rate_updated_at) that.usdtRateTime = res.data.rate_updated_at;
            if (res.data.min_deposit_usdt) that.usdtMin = res.data.min_deposit_usdt;
          } else {
            that.showTost(0, res.message || '地址获取失败,请稍后重试');
          }
        })
        .catch(() => {
          that.hideLoading();
        });
    },
    // 到账监听:首次快照已知到账 id,之后轮询,新到账即提示并刷新余额
    startDepositWatch() {
      let that = this;
      that.stopDepositWatch();
      that.$apiFun.post('/api/usdt_recent_deposits', {}).then(res => {
        if (res.code == 200 && res.data) {
          that.knownDepositIds = (res.data.list || []).map(x => x.id);
        }
      });
      that.depositTimer = setInterval(() => {
        that.pollDeposits(false);
      }, 8000);
    },
    stopDepositWatch() {
      if (this.depositTimer) {
        clearInterval(this.depositTimer);
        this.depositTimer = null;
      }
    },
    pollDeposits(manual) {
      let that = this;
      that.$apiFun.post('/api/usdt_recent_deposits', {}).then(res => {
        if (res.code == 200 && res.data) {
          let list = res.data.list || [];
          let ids = list.map(x => x.id);
          let newly = list.filter(x => that.knownDepositIds.indexOf(x.id) < 0);
          if (newly.length) {
            that.knownDepositIds = ids;
            let sum = newly.reduce((s, x) => s + (Number(x.amount) || 0), 0);
            that.showTost(1, 'USDT到账 +￥' + sum.toFixed(2) + '，已自动上分');
            that.getUserInfo();
          } else if (manual) {
            that.knownDepositIds = ids;
            that.showTost(1, '暂无新到账,请确认已转账或稍候再试');
            that.getUserInfo();
          }
        }
      });
    },
    checkDepositNow() {
      this.pollDeposits(true);
    },
    getProducts() {
      let that = this;
      that.products = [];
      that.selectedProduct = null;
      that.showLoading();
      that.$apiFun
        .get('/api/pay_products', { type: that.pay_way })
        .then(res => {
          if (res.code == 200 && Array.isArray(res.data)) {
            that.products = res.data;
            if (that.products.length) {
              that.selectProduct(that.products[0]);
            }
          }
          that.hideLoading();
        })
        .catch(() => {
          that.hideLoading();
        });
    },
    selectProduct(p) {
      this.selectedProduct = p;
      this.min_price = p.min_price;
      this.max_price = p.max_price;
      this.amount = null;
    },
    getPayRange() {
      let that = this;
      let type = null;

      if (that.pay_way == 'bank') {
        type = 'bank';
      }
      if (that.pay_way == 'wechat') {
        type = 'wechat';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'alipay') {
        type = 'alipay';
      }
      if (that.pay_way == 'usdt') {
        if (that.meyXi == 'ERC20') {
          type = 'usdt-erc20';
        }
        if (that.meyXi == 'TRC20') {
          type = 'usdt-trc20';
        }
      }
      // bank/wechat/alipay/usdt-erc20/usdt-trc20/ebpay    min_price max_price
      that.showLoading();

      that.$apiFun
        .post('/api/getPayRange', { type })
        .then(res => {
          if (res.code == 200) {
            that.min_price = res.data.min_price;
            that.max_price = res.data.max_price;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    changXiyi(val) {
      if (this.meyXi == val) {
        return;
      }
      this.meyXi = val;
      this.usdtAmount = null;
      this.loadUsdtAddress();
    },
    getPayWay() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .get('/api/get_pay_way', {})
        .then(res => {
          if (res.code == 200) {
            that.payWayList = res.data;
            that.payWayList.rengong = 1;
            let obj = that.payWayList;
            for (let i in obj) {
              if (obj[i] == 1) {
                that.pay_way = i == 'card' ? 'bank' : i;
                that.hideLoading();
                that.loadPayData();

                return;
              }
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    payTest() {
      let that = this;
      let info = {};

      // USDT 已改为静态地址自动上分,无需提交
      if (that.pay_way == 'usdt') {
        return;
      }

      // 支付宝/微信:第四方网关,选档 -> 下单 -> 跳 payurl
      if (that.pay_way == 'wechat' || that.pay_way == 'alipay') {
        if (!that.selectedProduct) {
          that.showTost(0, '请选择充值通道');
          return;
        }
        let amt = that.amount * 1;
        if (!amt || amt < that.selectedProduct.min_price || amt > that.selectedProduct.max_price) {
          that.showTost(0, `请输入金额在 ${that.selectedProduct.min_price}-${that.selectedProduct.max_price} 之间`);
          return;
        }
        if (that.submitting) {
          return;
        }
        that.submitting = true;
        that.showLoading();
        that.$apiFun
          .post('/api/recharge', {
            paytype: that.pay_way == 'wechat' ? 'wxpay' : 'alipay',
            amount: amt,
            product_id: that.selectedProduct.id,
            client: 'wap',
          })
          .then(res => {
            that.submitting = false;
            that.hideLoading();
            if (res.code == 200 && res.data && res.data.payurl) {
              window.location.href = res.data.payurl;
            } else {
              that.showTost(0, res.message || '下单失败,请稍后重试');
            }
          })
          .catch(() => {
            that.submitting = false;
            that.hideLoading();
          });
        return;
      }

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (that.pay_way == 'bank') {
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, '请输入存款人姓名');
          return;
        }
        if (!info.bank) {
          that.showTost(0, '请输入银行类型');
          return;
        }

        if (!info.bank_no) {
          that.showTost(0, '请输入银行卡号');
          return;
        }
        if (!info.bank_address) {
          that.showTost(0, '请输入银行开户行地址');
          return;
        }
      } else {
        //暂时
        info = {
          paytype: that.pay_way,
          amount: that.amount * 1,
        };
      }
      if (that.pay_way == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount < that.min_price || info.amount > that.max_price) {
        that.showTost(0, `请输入金额在${that.min_price}-${that.max_price}之间！`);
        return;
      }
      that.showLoading();
      info.paytype = info.paytype == 'wechat' ? 'wxpay' : info.paytype;

      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (that.pay_way == 'bank') {
              that.showTost(1, '提交成功，等待后台审核');
              that.bankBox = {};
              that.amount = null;
              that.hideLoading();
              that.$router.push({ path: '/transRecord' });
              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.$router.push({ path: `/payInfo?deposit_no=${res.message}` });
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changMey(val) {
      this.amount = val * 1;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      // 离开 USDT 时停止到账监听
      if (that.pay_way == 'usdt' && val != 'usdt') {
        that.stopDepositWatch();
      }
      that.pay_way = val;
      that.bankBox = {};
      that.payInfo = {};
      that.amount = null;
      that.usdtAmount = null;
      that.usdtAddr = {};
      that.selectedProduct = null;
      that.products = [];
      that.loadPayData();
    },
    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },
    doCopy(msg) {
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, '复制成功！');
    },
    getUserInfo() {
      let that = this;
      that.$parent.getUserInfo();
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    getuseCardlist() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.userbank = res.data;
        }
      });
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.userUSD = res.data;
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    this.stopDepositWatch();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      let that = this;
      vm.getuseCardlist();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.stopDepositWatch();
    next();
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/2d87bbdbffeb4734e5c7.css';

.tipsh {
  width: 95%;
  margin: 6px auto;
  border-radius: 10px;
  background: #f8f8f8;
  box-sizing: border-box;
  padding: 6px;

  .tops {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.4rem;
    font-weight: 700;
    color: #333;
    height: 1rem;
    span {
      font-size: 0.29rem;
      font-weight: 400;
    }
  }
  .tsg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tsgs {
      height: 0.56rem;
      line-height: 0.56rem;
      color: #a5a9b3;
      font-size: 0.2rem;
      text-align: center;
      padding: 4px 8px;
      flex: 1;
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAA0CAYAAADPCHf8AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALCSURBVHgB7d0hcNtAEIXhtWh4y8vDixseXHPz4ibYKW2Kw1UsHt7g8vCWB7u7mYsnss7S3elmam3+b8bjxM6Evaz1tFJWu91uKyLnAixbt1qt7qSyRh+3Aizfpf6xv5TKGk3dX31uBVi+jYak6qehJjx3+ngSYPmuNCTvpZLngOgUsXBU//wG/Adn+thqSM6kgpcJYiG516ffAizfO31cSQXNwfc/BfDhXKfIRmbqBUSniE2QewF8sGZrLTM0kdfsWIQDdnix1pB8lEKDgIQD9k4AP75oSD5IgdgEsZDYeZE/AvhgjVZR/duMvPdDAD+s2fqaW/8eDUg4YKf2hSf2MSur2Wom3mdPC95c5DRbowFhTwtOWbN1kfKDUxPEsKcFjzYpzdZkQNjTglNJzVbKBGFPC15NNltJAQnY04JHo81WckDY04JjR5utnAli2NOCV+vYJbtZAWFPC84Nmq3cCWIsIOxpwavt62YrOyBhirCnBa96l+yWTBD2tODd/pLdlRTShNkv4QQiPOuKJgjwRjzNCcisa32BE/dgFw4WBSRsQiZtQwILZFvs3+2L0gnyWQCfLBzXoa3ND0g4JV/t1o7AibnRcOzP82UFJDRX1e+gDZyIOw3H4+sXcieITY8q9zwFTkyr4RisUSUHJEwPDszh0UO41dVAzgTZCuDPvrGKSQpIqHU5MIc3vcYqZjIg4aMVtS68sVD0GquYlAlirRXTA960h41VzGhAqHXhVLSxipmaIOxbwZvuWGMVczQg7FvBocfc/6U+NkE4MIcn1lh9k0zRgLBvBWessbqeaqxiBgEJB+afBPDjtiQcJjZBmB7wxBqrX1KoFxD2reBMVmMVczhB2LeCF9mNVcw+IOxbwZGixirmOSDsW8GR4sYq5mWCMD3gxU2tcJgmTA9WSuBBG+76WY1NEMIBD9q5jVXMPzyG0oj5jr9QAAAAAElFTkSuQmCC);
      background-size: cover;
    }
  }
}
.usrse {
  background: #fff;
  box-sizing: border-box;
  padding-top: 5px;
  .hgs {
    width: calc(100% - 40px);
    margin: 0 auto;
  }
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }
  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;
    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }
    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}
[class*='van-hairline']:after {
  border: none;
}
.sc {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  .ssa {
    border-radius: 5px;
    border: 1px solid #f1f1f1;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.4rem;
    font-weight: 700;
    text-align: center;
    margin-left: 1rem;
  }
  .acti {
    color: #2f6bff !important;
    border: 1px solid #2f6bff !important;
  }
}
.typelis {
  width: 95%;
  margin: 6px auto;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .tyls {
    border-radius: 10px;
    border: 1px solid #eee;
    text-align: center;
    width: calc(25% - 0.2rem);
    padding: 0.2rem 0;
    font-size: 0.3rem;
    img {
      width: 0.7rem;
      display: block;
      margin: 0 auto;
      margin-bottom: 0.2rem;
    }
  }
  .tyls.atc {
    border: 1px solid #2f6bff;
    color: #2f6bff;
  }
}
.lasthg {
  display: flex;
  align-items: center;
  font-size: 0.33rem;
  color: #a5a9b3;
  padding: 0.2rem 0;
}
.usdtbanner {
  background-image: linear-gradient(135deg, #fff6f1, #fdeee6);
  border: 1px solid #f3d6c6;
  border-radius: 12px;
  padding: 0.28rem 0.34rem;
  margin: 0.24rem 0.3rem 0;
  .ub-title {
    font-size: 0.4rem;
    font-weight: 700;
    color: #cf5a2b;
    margin-bottom: 0.12rem;
  }
  .ub-desc {
    font-size: 0.32rem;
    line-height: 1.6;
    color: #7a6a63;
    b {
      color: #cf5a2b;
    }
  }
}
.usdtaddrbox {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 0.2rem 0.3rem;
  margin: 0.2rem 0;
  .addrtxt {
    flex: 1;
    font-size: 0.32rem;
    color: #333;
    word-break: break-all;
    font-family: monospace;
  }
  .copy {
    color: #fff;
    background: #2f6bff;
    border-radius: 6px;
    padding: 0.12rem 0.3rem;
    font-size: 0.32rem;
    margin-left: 0.2rem;
    white-space: nowrap;
  }
}
.qrwrap {
  text-align: center;
  padding: 0.2rem 0;
  img {
    width: 3.4rem;
    height: 3.4rem;
    object-fit: contain;
    border: 1px solid #eee;
    border-radius: 8px;
    background: #fff;
  }
  .qrtip {
    font-size: 0.3rem;
    color: #a5a9b3;
    margin-top: 0.1rem;
  }
}

.bans {
  background-image: linear-gradient(180deg, #fff, #f9fcff);
  width: 90%;
  margin: 0 auto;
  padding: 20px;
  border-radius: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .frists {
      width: 60px;
    }
    .sdsw {
      flex: 1;
    }
    .copy {
      color: #069b71;
    }
  }
}
.prodlist {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 0;
  .proditem {
    width: calc(50% - 8px);
    margin: 4px;
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 12px 6px;
    text-align: center;
    box-sizing: border-box;
    img {
      width: 0.8rem;
      height: 0.8rem;
      display: block;
      margin: 0 auto 6px;
      object-fit: contain;
    }
    .pname {
      font-size: 0.34rem;
      color: #333;
      font-weight: 700;
    }
    .prange {
      font-size: 0.28rem;
      color: #2f6bff;
      margin-top: 4px;
    }
  }
  .proditem.acti {
    border: 1px solid #2f6bff;
    background: #fff7f3;
  }
}
.quickbox {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0;
  .quickitem {
    min-width: 1.6rem;
    text-align: center;
    padding: 6px 10px;
    margin: 4px 8px 4px 0;
    border: 1px solid #eee;
    border-radius: 6px;
    font-size: 0.34rem;
    color: #333;
  }
  .quickitem.acti {
    border: 1px solid #2f6bff;
    color: #2f6bff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recharge.vue